import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, getTestId, Progress, Typography, useBreakpoint } from '@airtel/air-design-system';
import { View } from 'react-native';
import { getProgressBarItemStyles, isValidProgressValue } from './ProgressBarItemStyles';
export var ProgressBarItem = props => {
  var _useBreakpoint = useBreakpoint(),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var title = props.title,
    description = props.description,
    progressBarValue = props.progressBarValue,
    progressHintText = props.progressHintText,
    _props$progressBarPro = props.progressBarProps,
    progressBarProps = _props$progressBarPro === void 0 ? {} : _props$progressBarPro,
    isLastItem = props.isLastItem,
    testID = props.testID,
    ctaProps = props.ctaProps,
    ctaPressMetaData = props.ctaPressMetaData,
    id = props.id,
    onUserAction = props.onUserAction;
  var progressBarItemStyle = getProgressBarItemStyles(isSmallScreen, isLastItem);
  return _jsxs(View, Object.assign({
    style: progressBarItemStyle.container
  }, {
    children: [!!title && _jsx(Typography, Object.assign({
      text: title,
      type: "body-single-line-" + (isSmallScreen ? 'xs' : 'sm'),
      style: progressBarItemStyle.title
    }, getTestId(testID, 'title'))), _jsxs(View, Object.assign({
      style: progressBarItemStyle.descriptionContainer
    }, {
      children: [!!description && _jsx(Typography, Object.assign({
        text: description,
        type: "body-para-" + (isSmallScreen ? 'sm-bold' : 'md-bold'),
        style: progressBarItemStyle.description
      }, getTestId(testID, 'description'))), !!ctaProps && _jsx(Button, Object.assign({
        buttonType: "tertiary",
        onPress: () => {
          ctaPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
            id
          }, ctaPressMetaData), props));
        },
        style: progressBarItemStyle.description
      }, ctaProps, getTestId(testID, 'cta')))]
    })), isValidProgressValue(progressBarValue) && _jsx(Progress, Object.assign({
      type: 'linear',
      value: progressBarValue,
      hintText: progressHintText
    }, progressBarProps, getTestId(testID, 'progressBar')))]
  }));
};